/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v12.3.1.0 (NJsonSchema v9.14.1.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { AbpServiceBase } from '../abp-service-base';

export class DataHistoryServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * findDataList
     * @param vo vo
     * @return OK
     */
    findDataList(vo: FindDataHistoryVO): Promise<PagedResultVOOfDataHistoryDto> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iotmodel-storage')+ "/data-history/findDataList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(vo);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processFindDataList(_response);
        });
    }

    protected processFindDataList(response: AxiosResponse): Promise<PagedResultVOOfDataHistoryDto> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfDataHistoryDto.fromJS(resultData200) : new PagedResultVOOfDataHistoryDto();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfDataHistoryDto>(<any>null);
    }
}

export class IotExtranetLogServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getIotGatewayLog
     * @param gatewayLogVO gatewayLogVO
     * @return OK
     */
    getIotGatewayLog(gatewayLogVO: GetGatewayLogVO): Promise<PagedResultVOOfIotGatewayLog> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iotmodel-storage')+ "/extranet-log/get-iot-gateway-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(gatewayLogVO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotGatewayLog(_response);
        });
    }

    protected processGetIotGatewayLog(response: AxiosResponse): Promise<PagedResultVOOfIotGatewayLog> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfIotGatewayLog.fromJS(resultData200) : new PagedResultVOOfIotGatewayLog();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfIotGatewayLog>(<any>null);
    }

    /**
     * getIotServerLog
     * @param serverLogVO serverLogVO
     * @return OK
     */
    getIotServerLog(serverLogVO: GetServerLogVO): Promise<PagedResultVOOfIotServerLog> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iotmodel-storage')+ "/extranet-log/get-iot-server-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(serverLogVO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetIotServerLog(_response);
        });
    }

    protected processGetIotServerLog(response: AxiosResponse): Promise<PagedResultVOOfIotServerLog> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? PagedResultVOOfIotServerLog.fromJS(resultData200) : new PagedResultVOOfIotServerLog();
            return result200;
        }
        return Promise.resolve<PagedResultVOOfIotServerLog>(<any>null);
    }
}

export class IotExtranetTrafficServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getTrafficData
     * @param gatewayCode gatewayCode
     * @return OK
     */
    getTrafficData(gatewayCode: string): Promise<TrafficDataBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iotmodel-storage')+ "/extranet-traffic/get-traffic-data?";
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTrafficData(_response);
        });
    }

    protected processGetTrafficData(response: AxiosResponse): Promise<TrafficDataBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? TrafficDataBO.fromJS(resultData200) : new TrafficDataBO();
            return result200;
        }
        return Promise.resolve<TrafficDataBO>(<any>null);
    }

    /**
     * getTrafficDiffData
     * @param getTrafficDiffVO getTrafficDiffVO
     * @return OK
     */
    getTrafficDiffData(getTrafficDiffVO: QueryTrafficDiffVO): Promise<ROfTrafficDataDiffBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iotmodel-storage')+ "/extranet-traffic/get-traffic-data-diff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(getTrafficDiffVO);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json", 
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetTrafficDiffData(_response);
        });
    }

    protected processGetTrafficDiffData(response: AxiosResponse): Promise<ROfTrafficDataDiffBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ROfTrafficDataDiffBO.fromJS(resultData200) : new ROfTrafficDataDiffBO();
            return result200;
        }
        return Promise.resolve<ROfTrafficDataDiffBO>(<any>null);
    }
}

export class IotServerStatusServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * getServerStatus
     * @param gatewayCode gatewayCode
     * @return OK
     */
    getServerStatus(gatewayCode: string): Promise<ServerStatusBO> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iotmodel-storage')+ "/server-status/get-server-status?";
        if (gatewayCode === undefined || gatewayCode === null)
            throw new Error("The parameter 'gatewayCode' must be defined and cannot be null.");
        else
            url_ += "gatewayCode=" + encodeURIComponent("" + gatewayCode) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "*/*"
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processGetServerStatus(_response);
        });
    }

    protected processGetServerStatus(response: AxiosResponse): Promise<ServerStatusBO> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200 ? ServerStatusBO.fromJS(resultData200) : new ServerStatusBO();
            return result200;
        }
        return Promise.resolve<ServerStatusBO>(<any>null);
    }
}

export class TdengineServiceProxy extends AbpServiceBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor() {
        super();
        this.instance = this.ajax;
        this.baseUrl = this.ajaxBaseUrl;
    }

    /**
     * resetTables
     * @return OK
     */
    resetTables(): Promise<void> {
        let url_ = this.baseUrl + this.covertUrl('192.168.3.252/iotmodel-storage')+ "/tdengine/create-tables";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "POST",
            url: url_,
            headers: {
            }
        };

        return this.instance.request(options_).then((_response: AxiosResponse) => {
            return this.processResetTables(_response);
        });
    }

    protected processResetTables(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {}; 
        if (response.headers && response.headers.forEach) { 
            response.headers.forEach((v: any, k: any) => _headers[k] = v);
        };
        if (status === 200) {
            const _responseText = response.data ? (response.data.masterlink ? response.data.data: (response.data.code ? response.data : response.data.data)) : response
            return Promise.resolve<void>(<any>null);
        }
        return Promise.resolve<void>(<any>null);
    }
}

export class DataHistoryDto implements IDataHistoryDto {
    dataStatus!: number | undefined;
    propertyName!: string | undefined;
    propertyValue!: string | undefined;
    ts!: string | undefined;

    constructor(data?: IDataHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.dataStatus = data["dataStatus"];
            this.propertyName = data["propertyName"];
            this.propertyValue = data["propertyValue"];
            this.ts = data["ts"];
        }
    }

    static fromJS(data: any): DataHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new DataHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dataStatus"] = this.dataStatus;
        data["propertyName"] = this.propertyName;
        data["propertyValue"] = this.propertyValue;
        data["ts"] = this.ts;
        return data; 
    }
}

export interface IDataHistoryDto {
    dataStatus: number | undefined;
    propertyName: string | undefined;
    propertyValue: string | undefined;
    ts: string | undefined;
}

export class FindDataHistoryVO implements IFindDataHistoryVO {
    appCode!: number | undefined;
    current!: number | undefined;
    end!: Date | undefined;
    gatewayCode!: string | undefined;
    propertyName!: string | undefined;
    size!: number | undefined;
    start!: Date | undefined;

    constructor(data?: IFindDataHistoryVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.appCode = data["appCode"];
            this.current = data["current"];
            this.end = data["end"] ? new Date(data["end"].toString()) : <any>undefined;
            this.gatewayCode = data["gatewayCode"];
            this.propertyName = data["propertyName"];
            this.size = data["size"];
            this.start = data["start"] ? new Date(data["start"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FindDataHistoryVO {
        data = typeof data === 'object' ? data : {};
        let result = new FindDataHistoryVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appCode"] = this.appCode;
        data["current"] = this.current;
        data["end"] = this.end ? this.end.toISOString() : <any>undefined;
        data["gatewayCode"] = this.gatewayCode;
        data["propertyName"] = this.propertyName;
        data["size"] = this.size;
        data["start"] = this.start ? this.start.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IFindDataHistoryVO {
    appCode: number | undefined;
    current: number | undefined;
    end: Date | undefined;
    gatewayCode: string | undefined;
    propertyName: string | undefined;
    size: number | undefined;
    start: Date | undefined;
}

export class GetGatewayLogVO implements IGetGatewayLogVO {
    connectCode!: string | undefined;
    current!: number | undefined;
    endTime!: string | undefined;
    gatewayCode!: string | undefined;
    level!: string | undefined;
    message!: string | undefined;
    pcId!: string | undefined;
    size!: number | undefined;
    startTime!: string | undefined;
    threadId!: string | undefined;

    constructor(data?: IGetGatewayLogVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectCode = data["connectCode"];
            this.current = data["current"];
            this.endTime = data["endTime"];
            this.gatewayCode = data["gatewayCode"];
            this.level = data["level"];
            this.message = data["message"];
            this.pcId = data["pcId"];
            this.size = data["size"];
            this.startTime = data["startTime"];
            this.threadId = data["threadId"];
        }
    }

    static fromJS(data: any): GetGatewayLogVO {
        data = typeof data === 'object' ? data : {};
        let result = new GetGatewayLogVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectCode"] = this.connectCode;
        data["current"] = this.current;
        data["endTime"] = this.endTime;
        data["gatewayCode"] = this.gatewayCode;
        data["level"] = this.level;
        data["message"] = this.message;
        data["pcId"] = this.pcId;
        data["size"] = this.size;
        data["startTime"] = this.startTime;
        data["threadId"] = this.threadId;
        return data; 
    }
}

export interface IGetGatewayLogVO {
    connectCode: string | undefined;
    current: number | undefined;
    endTime: string | undefined;
    gatewayCode: string | undefined;
    level: string | undefined;
    message: string | undefined;
    pcId: string | undefined;
    size: number | undefined;
    startTime: string | undefined;
    threadId: string | undefined;
}

export class GetServerLogVO implements IGetServerLogVO {
    current!: number | undefined;
    endTime!: string | undefined;
    level!: string | undefined;
    message!: string | undefined;
    size!: number | undefined;
    startTime!: string | undefined;

    constructor(data?: IGetServerLogVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.current = data["current"];
            this.endTime = data["endTime"];
            this.level = data["level"];
            this.message = data["message"];
            this.size = data["size"];
            this.startTime = data["startTime"];
        }
    }

    static fromJS(data: any): GetServerLogVO {
        data = typeof data === 'object' ? data : {};
        let result = new GetServerLogVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["current"] = this.current;
        data["endTime"] = this.endTime;
        data["level"] = this.level;
        data["message"] = this.message;
        data["size"] = this.size;
        data["startTime"] = this.startTime;
        return data; 
    }
}

export interface IGetServerLogVO {
    current: number | undefined;
    endTime: string | undefined;
    level: string | undefined;
    message: string | undefined;
    size: number | undefined;
    startTime: string | undefined;
}

export class IotGatewayLog implements IIotGatewayLog {
    connectCode!: string | undefined;
    gatewayCode!: string | undefined;
    level!: string | undefined;
    message!: string | undefined;
    pcId!: string | undefined;
    threadId!: string | undefined;
    timestamp!: string | undefined;

    constructor(data?: IIotGatewayLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.connectCode = data["connectCode"];
            this.gatewayCode = data["gatewayCode"];
            this.level = data["level"];
            this.message = data["message"];
            this.pcId = data["pcId"];
            this.threadId = data["threadId"];
            this.timestamp = data["timestamp"];
        }
    }

    static fromJS(data: any): IotGatewayLog {
        data = typeof data === 'object' ? data : {};
        let result = new IotGatewayLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["connectCode"] = this.connectCode;
        data["gatewayCode"] = this.gatewayCode;
        data["level"] = this.level;
        data["message"] = this.message;
        data["pcId"] = this.pcId;
        data["threadId"] = this.threadId;
        data["timestamp"] = this.timestamp;
        return data; 
    }
}

export interface IIotGatewayLog {
    connectCode: string | undefined;
    gatewayCode: string | undefined;
    level: string | undefined;
    message: string | undefined;
    pcId: string | undefined;
    threadId: string | undefined;
    timestamp: string | undefined;
}

export class IotServerLog implements IIotServerLog {
    level!: string | undefined;
    message!: string | undefined;
    threadId!: string | undefined;
    timestamp!: string | undefined;

    constructor(data?: IIotServerLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.level = data["level"];
            this.message = data["message"];
            this.threadId = data["threadId"];
            this.timestamp = data["timestamp"];
        }
    }

    static fromJS(data: any): IotServerLog {
        data = typeof data === 'object' ? data : {};
        let result = new IotServerLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["level"] = this.level;
        data["message"] = this.message;
        data["threadId"] = this.threadId;
        data["timestamp"] = this.timestamp;
        return data; 
    }
}

export interface IIotServerLog {
    level: string | undefined;
    message: string | undefined;
    threadId: string | undefined;
    timestamp: string | undefined;
}

export class PagedResultVOOfDataHistoryDto implements IPagedResultVOOfDataHistoryDto {
    items!: DataHistoryDto[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfDataHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(DataHistoryDto.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfDataHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfDataHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfDataHistoryDto {
    items: DataHistoryDto[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfIotGatewayLog implements IPagedResultVOOfIotGatewayLog {
    items!: IotGatewayLog[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfIotGatewayLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(IotGatewayLog.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfIotGatewayLog {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfIotGatewayLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfIotGatewayLog {
    items: IotGatewayLog[] | undefined;
    totalCount: number | undefined;
}

export class PagedResultVOOfIotServerLog implements IPagedResultVOOfIotServerLog {
    items!: IotServerLog[] | undefined;
    totalCount!: number | undefined;

    constructor(data?: IPagedResultVOOfIotServerLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["items"] && data["items"].constructor === Array) {
                this.items = [] as any;
                for (let item of data["items"])
                    this.items!.push(IotServerLog.fromJS(item));
            }
            this.totalCount = data["totalCount"];
        }
    }

    static fromJS(data: any): PagedResultVOOfIotServerLog {
        data = typeof data === 'object' ? data : {};
        let result = new PagedResultVOOfIotServerLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.items && this.items.constructor === Array) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalCount"] = this.totalCount;
        return data; 
    }
}

export interface IPagedResultVOOfIotServerLog {
    items: IotServerLog[] | undefined;
    totalCount: number | undefined;
}

export class QueryTrafficDiffVO implements IQueryTrafficDiffVO {
    endTime!: string | undefined;
    gatewayCode!: string | undefined;
    startTime!: string | undefined;
    tableName!: string | undefined;
    timeIntervalCode!: string | undefined;

    constructor(data?: IQueryTrafficDiffVO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.endTime = data["endTime"];
            this.gatewayCode = data["gatewayCode"];
            this.startTime = data["startTime"];
            this.tableName = data["tableName"];
            this.timeIntervalCode = data["timeIntervalCode"];
        }
    }

    static fromJS(data: any): QueryTrafficDiffVO {
        data = typeof data === 'object' ? data : {};
        let result = new QueryTrafficDiffVO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["endTime"] = this.endTime;
        data["gatewayCode"] = this.gatewayCode;
        data["startTime"] = this.startTime;
        data["tableName"] = this.tableName;
        data["timeIntervalCode"] = this.timeIntervalCode;
        return data; 
    }
}

export interface IQueryTrafficDiffVO {
    endTime: string | undefined;
    gatewayCode: string | undefined;
    startTime: string | undefined;
    tableName: string | undefined;
    timeIntervalCode: string | undefined;
}

/** 返回信息 */
export class ROfTrafficDataDiffBO implements IROfTrafficDataDiffBO {
    /** 状态码 */
    code!: number;
    /** 承载数据 */
    data!: TrafficDataDiffBO | undefined;
    /** 返回消息 */
    msg!: string;
    /** 是否成功 */
    success!: boolean;

    constructor(data?: IROfTrafficDataDiffBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.code = data["code"];
            this.data = data["data"] ? TrafficDataDiffBO.fromJS(data["data"]) : <any>undefined;
            this.msg = data["msg"];
            this.success = data["success"];
        }
    }

    static fromJS(data: any): ROfTrafficDataDiffBO {
        data = typeof data === 'object' ? data : {};
        let result = new ROfTrafficDataDiffBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        data["msg"] = this.msg;
        data["success"] = this.success;
        return data; 
    }
}

/** 返回信息 */
export interface IROfTrafficDataDiffBO {
    /** 状态码 */
    code: number;
    /** 承载数据 */
    data: TrafficDataDiffBO | undefined;
    /** 返回消息 */
    msg: string;
    /** 是否成功 */
    success: boolean;
}

export class ServerStatusBO implements IServerStatusBO {
    authorizeCount!: string | undefined;
    dmpVersion!: string | undefined;
    dncFtpStatus!: string | undefined;
    dncSyncprocStatus!: string | undefined;
    extranetStatus!: string | undefined;
    remoteTerminalStatus!: string | undefined;
    smbdStatus!: string | undefined;
    vncServerStatus!: string | undefined;

    constructor(data?: IServerStatusBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.authorizeCount = data["authorizeCount"];
            this.dmpVersion = data["dmpVersion"];
            this.dncFtpStatus = data["dncFtpStatus"];
            this.dncSyncprocStatus = data["dncSyncprocStatus"];
            this.extranetStatus = data["extranetStatus"];
            this.remoteTerminalStatus = data["remoteTerminalStatus"];
            this.smbdStatus = data["smbdStatus"];
            this.vncServerStatus = data["vncServerStatus"];
        }
    }

    static fromJS(data: any): ServerStatusBO {
        data = typeof data === 'object' ? data : {};
        let result = new ServerStatusBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["authorizeCount"] = this.authorizeCount;
        data["dmpVersion"] = this.dmpVersion;
        data["dncFtpStatus"] = this.dncFtpStatus;
        data["dncSyncprocStatus"] = this.dncSyncprocStatus;
        data["extranetStatus"] = this.extranetStatus;
        data["remoteTerminalStatus"] = this.remoteTerminalStatus;
        data["smbdStatus"] = this.smbdStatus;
        data["vncServerStatus"] = this.vncServerStatus;
        return data; 
    }
}

export interface IServerStatusBO {
    authorizeCount: string | undefined;
    dmpVersion: string | undefined;
    dncFtpStatus: string | undefined;
    dncSyncprocStatus: string | undefined;
    extranetStatus: string | undefined;
    remoteTerminalStatus: string | undefined;
    smbdStatus: string | undefined;
    vncServerStatus: string | undefined;
}

export class TrafficDataBO implements ITrafficDataBO {
    dataTimes!: string[] | undefined;
    rec!: number | undefined;
    recs!: number[] | undefined;
    send!: number | undefined;
    sends!: number[] | undefined;

    constructor(data?: ITrafficDataBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (data["dataTimes"] && data["dataTimes"].constructor === Array) {
                this.dataTimes = [] as any;
                for (let item of data["dataTimes"])
                    this.dataTimes!.push(item);
            }
            this.rec = data["rec"];
            if (data["recs"] && data["recs"].constructor === Array) {
                this.recs = [] as any;
                for (let item of data["recs"])
                    this.recs!.push(item);
            }
            this.send = data["send"];
            if (data["sends"] && data["sends"].constructor === Array) {
                this.sends = [] as any;
                for (let item of data["sends"])
                    this.sends!.push(item);
            }
        }
    }

    static fromJS(data: any): TrafficDataBO {
        data = typeof data === 'object' ? data : {};
        let result = new TrafficDataBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.dataTimes && this.dataTimes.constructor === Array) {
            data["dataTimes"] = [];
            for (let item of this.dataTimes)
                data["dataTimes"].push(item);
        }
        data["rec"] = this.rec;
        if (this.recs && this.recs.constructor === Array) {
            data["recs"] = [];
            for (let item of this.recs)
                data["recs"].push(item);
        }
        data["send"] = this.send;
        if (this.sends && this.sends.constructor === Array) {
            data["sends"] = [];
            for (let item of this.sends)
                data["sends"].push(item);
        }
        return data; 
    }
}

export interface ITrafficDataBO {
    dataTimes: string[] | undefined;
    rec: number | undefined;
    recs: number[] | undefined;
    send: number | undefined;
    sends: number[] | undefined;
}

export class TrafficDataDiffBO implements ITrafficDataDiffBO {
    avg!: number | undefined;
    dataTimes!: string[] | undefined;
    max!: number | undefined;
    min!: number | undefined;
    total!: number | undefined;
    tras!: number[] | undefined;

    constructor(data?: ITrafficDataDiffBO) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.avg = data["avg"];
            if (data["dataTimes"] && data["dataTimes"].constructor === Array) {
                this.dataTimes = [] as any;
                for (let item of data["dataTimes"])
                    this.dataTimes!.push(item);
            }
            this.max = data["max"];
            this.min = data["min"];
            this.total = data["total"];
            if (data["tras"] && data["tras"].constructor === Array) {
                this.tras = [] as any;
                for (let item of data["tras"])
                    this.tras!.push(item);
            }
        }
    }

    static fromJS(data: any): TrafficDataDiffBO {
        data = typeof data === 'object' ? data : {};
        let result = new TrafficDataDiffBO();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["avg"] = this.avg;
        if (this.dataTimes && this.dataTimes.constructor === Array) {
            data["dataTimes"] = [];
            for (let item of this.dataTimes)
                data["dataTimes"].push(item);
        }
        data["max"] = this.max;
        data["min"] = this.min;
        data["total"] = this.total;
        if (this.tras && this.tras.constructor === Array) {
            data["tras"] = [];
            for (let item of this.tras)
                data["tras"].push(item);
        }
        return data; 
    }
}

export interface ITrafficDataDiffBO {
    avg: number | undefined;
    dataTimes: string[] | undefined;
    max: number | undefined;
    min: number | undefined;
    total: number | undefined;
    tras: number[] | undefined;
}